import { get } from 'js-cookie';


const getSessionId = () => {
  const sessionsCookie = get('_gpts');
  const decodedCookie = decodeURIComponent(sessionsCookie);

  return new URLSearchParams(decodedCookie).get('id');
};

export default getSessionId;
